import { en } from "./en";

export const resources = {
  en,
};
